export default __webpack_public_path__ + "static/media/7.929ab8a6.jpg";